<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div class="display-1 font-weight-medium blue--text">
        <v-icon large>local_gas_station</v-icon>
        Send Gas
      </div>
    </v-card-title>
    <v-card-text>
      <v-container fluid grid-list-md align-center text-xs-center>
        <v-flex xs10 offset-xs1>
          <v-layout row wrap>
            <v-flex xs10>
              <v-text-field
                label="User ID"
                v-model.trim="address"
                required
                outline
                background-color="blue lighten-3"
               ></v-text-field>
            </v-flex>
            <v-flex xs2 text-xs-center>
              <img src="~assets/images/scan_qrcode.png" class="cursor" @click="scanQrcode">
            </v-flex>
            <v-flex xs8>
              <v-text-field
                label="Amount (in HTML)"
                v-model.trim="amount"
                required
                outline
                background-color="blue lighten-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="Fee (in HTML)"
                v-model.trim="fee"
                required
                outline
                background-color="blue lighten-3"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-btn color="info" @click="send" :disabled="notValid">{{ $t('common.confirm') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-container>
    </v-card-text>
    <v-dialog v-model="confirmAddressDialog" persistent max-width="50%">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('send.enter_address') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="Address" v-model.trim="repeatAddress"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="confirmAddress">{{ $t('common.confirm') }}</v-btn>
          <v-btn class="red--text darken-1" flat @click.native="confirmAddressDialog = false">{{ $t('common.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmSendDialog" persistent max-width="50%">
      <v-card>
        <v-card-title>
          <span class="headline">
            You are going to send
            <v-chip label>{{this.amount}} {{this.symbol}}</v-chip>
            to the address
            <v-chip label>{{this.address}}</v-chip>. Do you confirm?
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-textarea label="Raw Tx" v-model="rawTx" disabled></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="confirmSend" v-show="canSend && !sending">
            {{ $t('common.confirm') }}
          </v-btn>
          <v-btn class="red--text darken-1" flat @click.native="confirmSendDialog = false" :v-show="!sending">
            {{ $t('common.cancel') }}
          </v-btn>
          <v-progress-circular indeterminate :size="50" v-show="sending" class="primary--text"></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="qrScan" max-width="50%">
      <v-container>
        <v-layout>
          <v-flex xs12 align-center text-xs-center>
            <qrcode-stream :track="false" @decode="onDecode" @init="onInit" :camera="camera" v-if="qrComponent" />
          </v-flex>
        </v-layout>    
      </v-container>
    </v-dialog>
  </v-card>
</template>

<script>
import webWallet from 'libs/web-wallet'
import hrc20 from 'libs/hrc20'
import server from 'libs/server'

import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'

export default {
  data () {
    return {
      address: '',
      amount: '',
      symbol: 'HTML',
      fee: '0.01',
      confirmAddressDialog: false,
      repeatAddress: '',
      confirmSendDialog: false,
      rawTx: 'loading...',
      canSend: false,
      sending: false,
      qrScan: false,
      camera: false,
      qrComponent: false
    }
  },
  components:{
    QrcodeStream,
    QrcodeCapture
  },
  computed: {
    notValid: function () {
       //@todo valid the address
       const amountCheck = /^\d+\.?\d*$/.test(this.amount) && this.amount > 0
       const feeCheck = /^\d+\.?\d*$/.test(this.fee) && this.fee > 0.0001
       return !(amountCheck && feeCheck)
    }
  },
  watch: {
    qrScan(val){
      if(!val)
        this.camera = false
    }
  },
  methods: {
    scanQrcode(){
      this.address = ''
      this.qrComponent = true
      this.camera = true
      this.qrScan = true
    },

    onDecode(scannedAddress) {
      this.address = scannedAddress
      this.camera = false
      this.qrScan = false
    },

    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    },

    send() {
      this.confirmAddressDialog = true
      this.canSend = false
    },

    async confirmAddress() {
      if (this.address !== this.repeatAddress) {
        this.$root.error('address_is_not_same_as_the_old_one')
        return false
      }
        this.confirmAddressDialog = false
        this.confirmSendDialog = true
        const wallet = webWallet.getWallet()
      try {
        if (wallet.extend.ledger) {
          this.rawTx = 'Please confirm tx on your ledger...'
        }
        this.rawTx = await wallet.generateTx(this.address, this.amount, this.fee)
        this.canSend = true
      } catch (e) {
      alert(e.message || e)
      this.$root.log.error('send_generate_tx_error', e.stack || e.toString() || e)
      this.confirmSendDialog = false
      return false
      }
    },

    async confirmSend() {
      this.sending = true
      try {
        const txId = await webWallet.getWallet().sendRawTx(this.rawTx)
        this.confirmSendDialog = false
        this.sending = false
        const txViewUrl = server.currentNode().getTxExplorerUrl(txId);
        this.$root.success(`Successful sent! You can follow the transaction on <a href="${txViewUrl}" target="_blank">${txViewUrl}</a>`, true, 0)
        this.$emit('send')
      } catch (e) {
        alert(e.message || e)
        this.$root.log.error('send_post_raw_tx_error', e.response || e.stack || e.toString() || e)
        this.confirmSendDialog = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/controllers/Send.vue